import { useI18n } from '@/context/I18nContext';
import { CrudPage, type CrudColumn, type CrudField } from '@/components/crud/CrudPage';

interface Carburetor {
  id: string;
  brand: string;
  type: string;
  nr?: string;
  teamId: string;
}

export function CarburetorsTab({ teamId, readOnly }: { teamId: string; readOnly?: boolean }) {
  const { t } = useI18n();

  const columns: CrudColumn<Carburetor>[] = [
    { key: 'brand', label: t('common.brand') },
    {
      key: 'type',
      label: t('common.type'),
      render: (c) => (
        <span className="inline-block px-2.5 py-0.5 bg-accent-subtle border border-accent/20 rounded-full text-xs font-medium text-accent-hover tracking-wide">
          {c.type}
        </span>
      ),
    },
    {
      key: 'nr',
      label: t('common.nr'),
      className: 'w-[80px] text-text-secondary tabular-nums text-sm',
      render: (c) => c.nr || <span className="text-text-muted">—</span>,
    },
  ];

  const fields: CrudField[] = [
    { key: 'brand', label: t('common.brand'), placeholder: "e.g. Dell'Orto" },
    { key: 'type', label: t('common.type'), placeholder: 'e.g. PHBH28' },
    { key: 'nr', label: t('common.nr'), placeholder: 'e.g. 1', info: t('common.nrInfo'), optional: true, defaultValue: (items) => String(items.length + 1) },
  ];

  return (
    <CrudPage<Carburetor>
      title={t('materials.tab.carburetors')}
      entityName={t('materials.entity.carburetor')}
      emptyIcon="⚙️"
      columns={columns}
      fields={fields}
      listMethod="ListCarburetors"
      createMethod="CreateCarburetor"
      updateMethod="UpdateCarburetor"
      deleteMethod="DeleteCarburetor"
      listParams={{ teamId }}
      readOnly={readOnly}
      hiddenValues={{ teamId }}
    />
  );
}
